// extracted by mini-css-extract-plugin
export default {"wrapper":"thNcz_RXmn7KwajzDV1c","label":"_hzNrTRAopR2_WM56t_p"};